import { render, staticRenderFns } from "./GPathCareerUnivScholarshipAdd.vue?vue&type=template&id=74c3ea91&scoped=true"
import script from "./GPathCareerUnivScholarshipAdd.vue?vue&type=script&lang=js"
export * from "./GPathCareerUnivScholarshipAdd.vue?vue&type=script&lang=js"
import style0 from "./GPathCareerUnivScholarshipAdd.vue?vue&type=style&index=0&id=74c3ea91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c3ea91",
  null
  
)

export default component.exports